import { useEffect, useState } from "react";
import { buildClass } from "@utils/tag";
import { Icon } from "@utils/helper";

const ScrollTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const startElement = document
      ?.getElementById("sharia-section")
      ?.getBoundingClientRect().top;

    const handleScroll = () => {
      if (window.scrollY > startElement) {
        setShow(true);
      } else {
        setShow(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={buildClass(
        "fixed bottom-5 z-50 cursor-pointer",
        "w-[43px] h-[43px] rounded-[10px]",
        "flex justify-center items-center",
        "bg-[#011291] ltr:left-24 rtl:right-24",
        { hidden: !show }
      )}
      style={{ border: "0.5px solid rgba(255, 255, 255, 0.45)" }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <Icon id="r1-c6" className="-rotate-90 font-bold" />
    </div>
  );
};

export default ScrollTop;
